import React from "react";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@fluentui/react-components";

interface DeletePopupProps {
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  actionProcessing: boolean;
}

const PortalDeletePopup: React.FC<DeletePopupProps> = ({
  open,
  onClose,
  onConfirmDelete,
  actionProcessing,
}) => {
  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogContent>This action cannot be undone.</DialogContent>
        <DialogActions>
          <Button appearance="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            appearance="primary"
            onClick={onConfirmDelete}
            disabled={actionProcessing}
            style={{ backgroundColor: "#d9534f", color: "white" }}
          >
            {actionProcessing ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};

export default PortalDeletePopup;
